import { connect } from 'react-redux';

import { createDeleteUser } from 'api/clients/clients.actions';
import { DeleteUserModalContent } from './DeleteUserModalContent';
import { createModalCloseAction } from 'actions/modalActions';
import { SimpleModalId } from 'constants/modalId';

const mapDispatchToProps = (dispatch: Function) => ({
  deleteUser: (userId: string) => dispatch(createDeleteUser(userId)),
  closeModal: () => dispatch(createModalCloseAction(SimpleModalId.DeleteUser)),
});

export const DeleteUserModalContentContainer = connect(null, mapDispatchToProps)(DeleteUserModalContent);
